/**
 * @param {string} selector
 */
function find(selector) {
  return document.querySelector(selector);
}


/**
 * @param {string} selector
 */
function findAll(selector) {
  return Array.from(document.querySelectorAll(selector));
}


/**
 * @param {Element} $el
 * @param {string} selector
 */
function findFrom($el, selector) {
  return $el.querySelector(selector);
}


/**
 * @param {Element} $el
 * @param {string} selector
 */
function findAllFrom($el, selector) {
  return Array.from($el.querySelectorAll(selector));
}


/**
 * @param {HTMLElement} $el
 */
function hide($el) {
  $el.style.setProperty('display', 'none');
}


/**
 * @param {HTMLElement} $el
 */
function unhide($el) {
  $el.style.removeProperty('display');
}


/**
 * @param {HTMLElement} $el
 * @param {boolean} force
 */
function toggle($el, force) {
  const isUnhiding = force === true ||
    (force !== false && $el.style.display === 'none');

  if (isUnhiding) {
    unhide($el);
  } else {
    hide($el);
  }
}


/**
 * @param {HTMLElement} $el
 */
function empty($el) {
  $el.innerHTML = '';
}


/**
 * @param {HTMLElement} $el
 * @param {HTMLElement} $content
 */
function replaceChildren($el, $content) {
  empty($el);
  $el.appendChild($content);
}


/**
 * @param {HTMLElement} $parent
 * @param {HTMLElement} $el
 */
function prepend($parent, $el) {
  $parent.insertAdjacentElement('afterbegin', $el);
}


/**
 * @param {HTMLElement} $parent
 * @param {HTMLElement} $el
 */
function appendAfter($parent, $el) {
  $parent.insertAdjacentElement('afterend', $el);
}


/**
 * @param {string} elementType
 * @param {{name: string}} attrs
 */
function makeElement(elementType, attrs) {
  const $el = document.createElement(elementType);

  if (attrs) {
    Object.entries(attrs)
      .forEach(([name, value]) => $el.setAttribute(name, value));
  }

  return $el;
}


/**
 * @param {string} html
 */
function parseElement(html) {
  const $temp = document.createElement('div');
  $temp.innerHTML = html;

  if ($temp.childElementCount > 1) {
    throw new Error(`Attempted to parse a single Element from multi-Element HTML: ${html}`);
  }

  return $temp.firstElementChild;
}


/**
 * @param {HTMLElement} $el
 */
function remove($el) {
  $el.parentElement.removeChild($el);
}


/**
 * @param {HTMLElement} $el
 * @param {string} selector
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
 */
function matches($el, selector) {
  if (Element.prototype.matches) {
    return $el.matches(selector);
  }

  return $el.msMatchesSelector(selector);
}


/**
 * @param {HTMLElement} $el
 * @param {string} selector
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
function closest($el, selector) {
  if (Element.prototype.closest) {
    return $el.closest(selector);
  }

  if (!document.documentElement.contains($el)) {
    return null;
  }

  let $parent = $el;

  do {
    if (matches($parent, selector)) {
      return $parent;
    }
    $parent = $parent.parentElement || $parent.parentNode;
  } while (
    $parent !== null && $parent.nodeType === Node.ELEMENT_NODE
  );

  return null;
}


/**
 * @param {HTMLElement} $el
 */
function disable($el) {
  $el.setAttribute('disabled', '');
}


/**
 * @param {HTMLElement} $el
 */
function enable($el) {
  $el.removeAttribute('disabled');
}


export default {
  find,
  findAll,
  findFrom,
  findAllFrom,
  hide,
  unhide,
  toggle,
  empty,
  replaceChildren,
  prepend,
  appendAfter,
  makeElement,
  parseElement,
  remove,
  matches,
  closest,
  disable,
  enable,
};



// WEBPACK FOOTER //
// ./V7/utils/dom.js